// extracted by mini-css-extract-plugin
var _1 = "lG88j";
var _2 = "z9r6v";
var _3 = "nY0fp";
var _4 = "xxPt2";
var _5 = "bCN8J";
var _6 = "QjCk5";
var _7 = "dXFRG";
export { _1 as "downloadItemButtonIcon", _2 as "downloadItemFooter", _3 as "downloadItemHeader", _4 as "downloadItemImage", _5 as "downloadItemLink", _6 as "downloadItemLinkIcon", _7 as "downloadItemMeta" }
